import { categoryService } from "../../../services";

export const newAssetLoader = async () => {
  try {
    let categories = await categoryService.AllCategories();
    categories = categories.map((category) => ({
      ...category,
      name: category.platform.name + " " + category.name,
    }));

    return { categories };
  } catch (err) {
    throw new Response(err.message || "Failed to load categories", { status: 500 });
  }
};
